module.exports = __webpack_public_path__ + "img/logo.1ae7f878.svg";